import { useState } from 'react'

import { SegmentedControl } from '@/components/ui/segmented-control'
import { Demo, DsSection } from '../primitives'

export function SegmentedControlSection() {
  const [billing, setBilling] = useState('monthly')
  const [sort, setSort] = useState('best')

  return (
    <DsSection id="segmented-control" title="Segmented control">
      <Demo label="Two options — hugs its content">
        <SegmentedControl
          value={billing}
          onValueChange={setBilling}
          options={[
            { value: 'annual', label: 'Annual' },
            { value: 'monthly', label: 'Monthly' },
          ]}
        />
      </Demo>
      <Demo label="Fills its container — pass a width/flex className">
        <SegmentedControl
          className="w-full max-w-sm"
          value={sort}
          onValueChange={setSort}
          options={[
            { value: 'best', label: 'Best' },
            { value: 'cheapest', label: 'Cheapest' },
            { value: 'fastest', label: 'Fastest' },
          ]}
        />
      </Demo>
    </DsSection>
  )
}
